import { Link, useLocation } from "react-router-dom";

/**
 * Primary information architecture (2026 redesign).
 *
 * "Blogs" and "Series" were the old labels for the same idea at two levels;
 * they now read as what they are: Read (series you work through) and Learn
 * (courses made of those series). Kids is a deep link into the category
 * rather than a separate section, so it stays one source of content.
 */
export const navigationLinks = [
  {
    to: "/blogs",
    label: "Read",
    isActive: (path: string, search: string) =>
      path.startsWith("/blog") && !search.includes("kids-programming"),
  },
  {
    to: "/series",
    label: "Learn",
    isActive: (path: string) => path.startsWith("/series"),
  },
  {
    to: "/blogs?category=kids-programming",
    label: "Kids",
    isActive: (path: string, search: string) =>
      path === "/blogs" && search.includes("kids-programming"),
  },
  {
    to: "/about",
    label: "About",
    isActive: (path: string) => path === "/about",
  },
];

interface NavigationLinksProps {
  onNavClick?: () => void;
  className?: string;
}

export function NavigationLinks({ onNavClick, className = "" }: NavigationLinksProps) {
  const { pathname, search } = useLocation();

  return (
    <ul className={className}>
      {navigationLinks.map((link) => {
        const active = link.isActive(pathname, search);
        return (
          <li key={link.label}>
            <Link
              to={link.to}
              onClick={onNavClick}
              aria-current={active ? "page" : undefined}
              className={`font-headline font-semibold tracking-tight text-[15px] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded px-1 py-1 ${
                active
                  ? "text-foreground border-b-2 border-primary pb-0.5"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              {link.label}
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
